export default __webpack_public_path__ + "img/fc56996d64e76cd4fa2663d65602aae6.png";